import { useEffect, useState } from 'react';
import { getMyStats } from '../../api';
import type { UserStats } from '../../types';
import { useAuthStore } from '../../store/authStore';
import './Stats.css';

export function Stats() {
  const [stats, setStats] = useState<UserStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const user = useAuthStore(s => s.user);

  useEffect(() => {
    getMyStats()
      .then(setStats)
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, []);

  if (isLoading) return <div className="stats-loading">Loading stats...</div>;
  if (!stats) return <div className="stats-empty">No stats available.</div>;

  return (
    <div className="stats">
      <h2>{user?.first_name || user?.username || 'Profile'}</h2>
      {user?.username && <p className="stats-username">@{user.username}</p>}

      <div className="stats-grid">
        <StatBox label="Total Solved" value={stats.solved_total} />
        <StatBox label="Today" value={stats.solved_today} />
        <StatBox label="This Week" value={stats.solved_this_week} />
        <StatBox label="Streak" value={`${stats.streak_days}d`} />
        <StatBox label="Accuracy" value={`${Math.round(stats.accuracy * 100)}%`} />
        <StatBox
          label="Daily Progress"
          value={`${stats.daily_progress.solved}/${stats.daily_progress.total}`}
        />
      </div>

      <h3>By Difficulty</h3>
      <div className="difficulty-stats">
        {Object.entries(stats.solved_by_difficulty).sort(([a], [b]) => Number(a) - Number(b)).map(([diff, count]) => (
          <div key={diff} className="diff-row">
            <span className="diff-label">Level {diff}</span>
            <div className="diff-bar-container">
              <div
                className="diff-bar"
                style={{ width: `${Math.min(100, (count as number / Math.max(stats.solved_total, 1)) * 100)}%` }}
              />
            </div>
            <span className="diff-count">{count as number}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function StatBox({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="stat-box">
      <div className="stat-value">{value}</div>
      <div className="stat-label">{label}</div>
    </div>
  );
}
